import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const VariantSelector = ({
  title,
  handleVariantSelect,
  panelVariants,
  selectedVariantId,
}) => {
  if (!panelVariants) {
    return null;
  }

  return (
    <>
      <section className="variant-selector">
        <h3 className="variant-selector__title">{title}</h3>
        <fieldset className="variant-selector__container">
          {panelVariants.map(
            ({ id, imageUrl, name, description, bulletPoints } = {}, index) => {
              return (
                <label key={id}>
                  <input
                    defaultChecked={
                      selectedVariantId ? selectedVariantId === id : index === 0
                    }
                    type="radio"
                    name="variant"
                    className="variant-selector-input"
                    onClick={() => handleVariantSelect(id)}
                  />
                  <div className="variant-selector-card">
                    <div className="variant-selector-card__dot">
                      <div className="variant-selector-card__inner-dot" />
                    </div>
                    <h3 className="variant-selector-card__title">{name}</h3>
                    <div className="variant-selector-card__middle-content">
                      <div className="variant-selector-card__image-wrapper">
                        <img
                          src={imageUrl}
                          alt=""
                          className="variant-selector-card__image"
                        />
                      </div>
                      <div className="variant-selector-card__selling-points-container">
                        {bulletPoints ? parse(bulletPoints) : null}
                      </div>
                    </div>
                    <div className="variant-selector-card__description">
                      {description ? parse(description) : null}
                    </div>
                  </div>
                </label>
              );
            }
          )}
        </fieldset>
      </section>
    </>
  );
};

VariantSelector.propTypes = {
  title: PropTypes.string,
  handleVariantSelect: PropTypes.func,
  panelVariants: PropTypes.array,
  selectedVariantId: PropTypes.number,
};

export default VariantSelector;
